// extracted by mini-css-extract-plugin
export default {"banner":"style_banner__dGwpC","inner":"style_inner__GObfM","icon":"style_icon__KTe8F","text":"style_text__y6ne6"};